<template>
  <div>
    <div>
      <fieldset>
        <div class="Flex_Table">
          <div class="Flex_Row">
            <div class="Flex_Cell" style="width: 20%">
              <label for="ddlAdvertisment" class="mandatorySpan" :class="{ Required: true }"
                >Advertisement For</label
              >
              <select
                id="ddlAdvertisment"
                v-model="advtID"
                v-on:change="getStatus()"
              >
                <option value="-1">---Select---</option>
                <option v-for="c in advtList" :key="c[0]" v-bind:value="c[0]">
                  {{ c[1] }}
                </option>
              </select>
            </div>
            <div class="Flex_Cell" style="width: 20%" >
              <span class="mandatorySpan" :class="{ Required: true }" v-if="type==2"
                >From Date</span
              >
              <DateControl
                v-model="fromDate"
                :showDate="true"
                title="Enter From Date Of Daily Backup"
                v-if="type==2"
              ></DateControl>
            </div>
            <div class="Flex_Cell" style="width: 20%" >
              <span class="mandatorySpan" :class="{ Required: true }" v-if="type==2"
                >To Date</span
              >
              <DateControl
                v-model="toDate"
                :showDate="true"
                title="Enter To Date Of Daily Backup"
                v-if="type==2"
              ></DateControl>
            </div>
            <div class="Flex_Cell" style="width: 25%">
              <span class="file_count">
                <input
                  type="button"
                  id="btnRefresh"
                  value="Refresh"
                  style="margin-top: -10px"
                  v-on:click="getStatus()"
                />
                <input
                  type="button"
                  id="btnDailyStatus"
                  value="Show Daily Status"
                  style="margin-top: -10px"
                  v-on:click="showDaily()"
                />
              </span>
            </div>
            <div class="Flex_Cell" style="width: 15%" align="right" valign="middle">
              <span style="text-align:right;color: #8a0000; font-weight: bold">* Fields are mandatory </span>
            </div>
          </div>
        </div>
      </fieldset>
    </div>

    <div class="dvLegend">
      <i
        class="fa fa-caret-square-o-up"        
        style="color: #0033ff; font-size: 30px"
      ></i
      ><span style="color: #0033ff; font-weight: bold">Not Uploaded</span>
      <i
        class="fa fa-arrow-circle-down"        
        style="color: #0033ff; font-size: 30px"
      ></i>
      <span style="color: #0033ff; font-weight: bold">Not Downloaded</span>
      <i
        class="fa fa-caret-square-o-up"        
        style="color: #33c40a; font-size: 30px"
      ></i
      ><span style="color: #114502; font-weight: bold">Upload Done</span>
      <i
        class="fa fa-arrow-circle-down"        
        style="color: #33c40a; font-size: 30px"
      ></i>
      <span style="color: #114502; font-weight: bold">Download Done</span>
      <i
        class="fa fa-caret-square-o-up"        
        style="color: #ff0000; font-size: 30px"
      ></i
      ><span style="color: #8a0000; font-weight: bold">Upload Error</span>
      <i
        class="fa fa-arrow-circle-down"        
        style="color: #ff0000; font-size: 30px"
      ></i>
      <span style="color: #8a0000; font-weight: bold">Download Error</span>
      <span class="file_count" style="margin-top: 7px">
        <input
          type="checkbox"
          v-model="autoRefreshOn"
          title="Auto Refresh On / Off "
          v-on:change="refreshOnOff"
        />
        <label class="timer_count">Auto Refresh in:{{ timer }} seconds</label>
      </span>
    </div>

    <div class="">
      <div class="Flex_Table dvStatus" style="width: 100%">
        <div class="Flex_Row header">
          <div
            v-for="(header, hindex) in statusData[0]"
            :key="hindex"
            v-if="header != 'X'"
            :class="'Flex_Cell cls' + hindex"
            align="center"
            valign="middle"
            style="width: 11%"
          >
            {{ header }}
          </div>
        </div>
        <div
          class="Flex_Row rowTotal"
          v-for="row in statusData.filter((s) => {
            return s[22] == '3';
          })"
          :key="row[0]"
        >
          <div
            v-for="(col, rindex) in row"
            v-if="statusData[0][rindex] != 'X'"
            :class="'Flex_Cell cls' + rindex"
            align="center"
            valign="middle"
            style="width: 11%"
          >
            <span v-if="rindex == 1">
              {{ col }}
            </span>
            <div v-if="rindex != 1" class="totalDv">
              <i
                :class="'fa fa-caret-square-o-up color' + col.split(',')[0]"                
                style="color: #33c40a; font-size: 25px"
                title="Total backup uploaded"
              ></i>
              <span>{{ col.split(",")[0] }}</span>
              <i
                :class="'fa fa-arrow-circle-down color' + col.split(',')[1]"                
                style="color: #33c40a; font-size: 25px"
                title="Total backup downloaded"
              ></i>
              <span>{{ col.split(",")[1] }}</span>
            </div>
          </div>
        </div>
        <div class="Flex_Table rowData">
          <div
            class="Flex_Row row"
            v-for="row in statusData.filter((s) => {
              return s[22] == '4';
            })"
            :key="row[0]"
          >
            <div
              v-for="(col, rindex) in row"
              v-if="statusData[0][rindex] != 'X'"
              :class="'Flex_Cell cls' + rindex"
              align="center"
              valign="middle"
              style="width: 11%"
            >
              <span v-if="rindex == 1">
                {{ col }}
              </span>
              <div v-if="rindex != 1">
                <i
                  :class="
                    'fa fa-caret-square-o-up click_obj color' +
                    col.split(',')[0]
                  "                  
                  v-on:click="redirectPage(1, row[0], statusData[1][rindex])"
                ></i>
                <i
                  :class="
                    'fa fa-arrow-circle-down click_obj color' +
                    col.split(',')[1]
                  "                  
                  v-on:click="redirectPage(2, row[0], statusData[1][rindex])"
                ></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import vue from "vue";
import axios from "axios";
import DateControl from "./ekkControls/DateControl";
import config from "@/router/globalConfig";

export default {
  name: "UploadDownloadStatus",
  components: {
    DateControl: DateControl,
  },
  data() {
    return {
      advtID: -1,
      fromDate: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).convertToString(
        "dd MMM yyyy"
      ),
      toDate: new Date().convertToString("dd MMM yyyy"),
      advtList: [],
      statusData: [],
      type: "1",
      timer: 0,
      autoRefTimer: null,
      autoRefreshOn: false,
    };
  },
  mounted() {
    this.getAdvt();
  },
  methods: {
    getAdvt() {
      const _data_ = { type: "2" };
      axios
        .get(config.WEB_API_PATH + "Master/GetAdvertisment", {
          headers: {
            __RequestVerificationToken: config.AF_Token,
            Authorization: config.LOG_Token,
          },
          params: _data_,
          crossdomain: true,
        })
        .then(
          (response) => {
            this.advtList = response.data;
            if (this.advtList.length > 0) {
              this.advtID = this.advtList[0][0];
              this.getStatus();
            }
          },
          (error) => {}
        );
    },
    showDaily() {
      if (this.type == "1") {
        document.getElementById("btnDailyStatus").value = "Show Backup Status";
        this.type = "2";
      } else {
        document.getElementById("btnDailyStatus").value = "Show Daily Status";
        this.type = "1";
      }
      this.getStatus();
    },
    getStatus() {
      const _data_ = {
        advtID: this.advtID,
        fromDate: this.fromDate,
        toDate: this.toDate,
        type: this.type,
      };
      axios
        .get(
          config.WEB_API_PATH + "UploadDownloadStatus/GetUploadDownloadStatus",
          {
            headers: {
              __RequestVerificationToken: config.AF_Token,
              Authorization: config.LOG_Token,
            },
            params: _data_,
            crossdomain: true,
          }
        )
        .then(
          (response) => {
            this.statusData = response.data;
          },
          (error) => {}
        );
    },
    countDownTimer() {
      let me = this;
      this.autoRefTimer = setInterval(() => {
        me.timer--;
        if (me.timer == 0) {
          me.getStatus();
          me.timer = 60;
        }
      }, 1000);
    },
    refreshOnOff() {
      if (this.autoRefreshOn) {
        this.timer = 60;
        this.countDownTimer();
      } else {
        this.timer = 0;
        if (this.autoRefTimer != null) clearInterval(this.autoRefTimer);
      }
    },
    redirectPage(eventType, examCentreID, backupTypeID) {
      //alert(eventType + "," + examCentreID + "," + backupTypeID);
      if (backupTypeID.split(",")[eventType] == 0) {
        window.MessageBox.show({
          message: "Not applicable",
          type: "error",
          title: "Message",
        });
        return false;
      }
      let obj = new Object();
      obj.EventType = eventType;
      obj.ExamCentreID = examCentreID;
      obj.BackupTypeID = backupTypeID.split(",")[0];
      this.$root.$data.StatusData = obj;
      this.$router.push({ name: "FileDrive" });
    },
  },
  beforeDestroy() {
    if (this.autoRefTimer != null) clearInterval(this.autoRefTimer);
  },
};
</script>
<style scoped>
.mandatorySpan {
  text-align: left;
  position: relative;
  display: block;
  padding: 0;
  margin-bottom: 5px;
  font-weight: bold;
}
.mandatorySpan.Required:after {
  color: red;
  content: "*";
  position: absolute;
  height: 8px;
  top: -5px;
  font-size: 200%;
}
#btnRefresh,
#btnDailyStatus {
  background-color: #000;
  color: #ff940b;
  border: none;
  border-radius: 5px;
  font-weight: 900;
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    from(hsla(0, 0%, 100%, 0.2)),
    to(hsla(0, 0%, 100%, 0.05))
  );
  background-image: linear-gradient(
    hsla(0, 0%, 100%, 0.2),
    hsla(0, 0%, 100%, 0.05)
  );
  margin-top: 5px;
  padding: 5px 14px 4px 13px;
}
.dvLegend {
  background-color: #f8f3f9;
  border: black 1px solid;
  padding: 2px;
}
.dvStatus {
  border-left: solid #2a80ba 3px;
  border-right: solid #2a80ba 3px;
  border-bottom: solid #2a80ba 3px;
  background-color: #fff;
}
.cls22 {
  display: none;
}
.cls1 {
  background-color: #488bda;
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    from(rgba(255, 255, 255, 0.2)),
    to(rgba(255, 255, 255, 0.05))
  );
  background-image: linear-gradient(
    rgba(255, 255, 255, 0.2),
    rgba(255, 255, 255, 0.05)
  );
  color: #ffffff;
  border: 1px solid #1677b0;
  font-size: 14px;
  font-weight: bold;
}
.header {
  background-color: #cbd3d5;
  color: #000;
  border: none;
  font-weight: bold;
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    from(rgba(255, 255, 255, 0.2)),
    to(rgba(255, 255, 255, 0.05))
  );
  background-image: linear-gradient(
    rgba(255, 255, 255, 0.2),
    rgba(255, 255, 255, 0.05)
  );
  margin-top: 5px;
  min-height: 80px;
}
.rowData {
  width: 100%;
  height: calc(100vh - 335px);
  overflow: auto;
}
.row {
  height: 35px;
}
.row:hover {
  background-color: #7ad6e4;
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    from(rgba(255, 255, 255, 0.2)),
    to(rgba(255, 255, 255, 0.05))
  );
}
.rowTotal,
.rowTotal .cls1 {
  background-color: #000;
  color: white;
  border: none;
  font-weight: bold;
  font-size: 15px;
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    from(rgba(255, 255, 255, 0.2)),
    to(rgba(255, 255, 255, 0.05))
  );
  background-image: linear-gradient(
    rgba(255, 255, 255, 0.2),
    rgba(255, 255, 255, 0.05)
  );
}
.totalDv {
  width: 100%;
  padding: 5px;
  font-family: Garamond, serif;
  line-height: 1em;
  color: #fff9d6;
  font-weight: bold;
  font-size: 16px;
  border-radius: 15px;
  /* border-bottom-right-radius: 15px; */
  box-shadow: 0px 0px 15px #ecc4c4;
  border-right: solid 1px #0d2d40;
  background-image: -webkit-gradient(
    linear,
    left bottom,
    left top,
    color-stop(0.1, rgba(0, 0, 0, 0.45)),
    color-stop(1, rgba(255, 255, 255, 0.3))
  );
  background-image: -moz-linear-gradient(
    center bottom,
    rgba(0, 0, 0, 0.45) 1%,
    rgba(255, 255, 255, 0.3) 100%
  );
  background-image: gradient(
    center bottom,
    rgba(0, 0, 0, 0.45) 1%,
    rgba(255, 255, 255, 0.3) 100%
  );
  background-image: -ms-linear-gradient(
    bottom,
    rgba(0, 0, 0, 0.45) 1%,
    rgba(255, 255, 255, 0.3) 100%
  );
}
.click_obj:hover {
  background-color: #def0f1;
  cursor: pointer;
  padding: 2px;
  border-radius: 15px;
  /* border-bottom-right-radius: 15px; */
  box-shadow: 0px 0px 15px #6185d8;
  border-right: solid 1px #0d2d40;
  background-image: -webkit-gradient(
    linear,
    left bottom,
    left top,
    color-stop(0.1, rgba(0, 0, 0, 0.45)),
    color-stop(1, rgba(255, 255, 255, 0.3))
  );
  background-image: -moz-linear-gradient(
    center bottom,
    rgba(0, 0, 0, 0.45) 1%,
    rgba(255, 255, 255, 0.3) 100%
  );
  background-image: gradient(
    center bottom,
    rgba(0, 0, 0, 0.45) 1%,
    rgba(255, 255, 255, 0.3) 100%
  );
  background-image: -ms-linear-gradient(
    bottom,
    rgba(0, 0, 0, 0.45) 1%,
    rgba(255, 255, 255, 0.3) 100%
  );
}
.file_count {
  float: right;
  margin-top: 17px;
  margin-right: 10px;
}
.timer_count {
  color: #8a0000;
  font-size: 15px;
  margin-top: -10px;
}
.color1 {
  color: #0033ff;
  font-size: 30px;
}
.color2 {
  color: #ff0000;
  font-size: 30px;
}
.color3 {
  color: #33c40a;
  font-size: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/UploadDownloadStatus.vue